import {Component, OnInit} from '@angular/core';
import {TenantConfig} from '../model/tenant-config';
import {TenantConfigService} from '../service/tenant-config.service';

@Component({
    selector: 'app-kontakt',
    templateUrl: './kontakt.component.html',
    styleUrls: ['./kontakt.component.css'],
    imports: [],
    standalone: true
})
export class KontaktComponent implements OnInit {

  tenant!: TenantConfig;

  constructor(tenantConfigService: TenantConfigService) {
    this.tenant = tenantConfigService.current;
  }

  ngOnInit(): void {
  }

}
